import { render } from "./Child-List-Item-Select.vue?vue&type=template&id=b44c23a0&scoped=true"
import script from "./Child-List-Item-Select.vue?vue&type=script&lang=js"
export * from "./Child-List-Item-Select.vue?vue&type=script&lang=js"

import "./Child-List-Item-Select.vue?vue&type=style&index=0&id=b44c23a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44c23a0"]])

export default __exports__